import axios from 'axios';

export function acceptTender(hash, data)
{
    const route = '/shared/tenders/accept/{hash}';
    return axios.post(route.replace('{hash}', hash), data);
}

export function declineTender(hash, message)
{
    const route = '/shared/tenders/decline/{hash}';
    return axios.post(route.replace('{hash}', hash), {hash, message});
}
